import $i18n from '@/locales/i18n';
import { BLOCK, COL, SECTION } from '@/common/util/const';
export function getObjectSetterSnippet(config) {
    const { items, initialValue } = config || {};
    const temp = {
        componentName: 'ObjectSetter',
        props: {
            config: {
                items,
            },
        },
    };
    if (initialValue) {
        temp.initialValue = initialValue;
    }
    return temp;
}
export function getArraySetterSnippet(config) {
    const { initialValue, configure } = config || {};
    return {
        componentName: 'ArraySetter',
        props: {
            mode: 'list',
            itemSetter: {
                componentName: 'ObjectSetter',
                initialValue,
                props: {
                    config: {
                        items: configure,
                    },
                },
            },
        },
    };
}
export const createBlockInitialChildrenSnippet = ({ cardProps = {}, children, }) => {
    const baseSnippet = {
        componentName: 'CnCard',
        title: $i18n.get({ id: 'Card', dm: '卡片' }),
        props: {
            isCnCard: true,
            _context: {
                type: 'JSExpression',
                value: 'this',
            },
            shape: 'normal',
            title: $i18n.get({ id: 'Title', dm: '标题' }),
            ...cardProps,
        },
    };
    return children
        ? {
            ...baseSnippet,
            children: [children],
        }
        : baseSnippet;
};
// 构造分组卡片Schema，用于迁移Section相关属性
export const createGroupCard = ({ title, headerBottomSlot, buttons, children } = {}) => {
    return {
        componentName: 'CnCard',
        title: $i18n.get({ id: 'Card', dm: '卡片' }),
        props: {
            isCnCard: true,
            _context: {
                type: 'JSExpression',
                value: 'this',
            },
            shape: 'group',
            title,
            slotManager: {
                headerBottomSlot,
            },
            buttons,
        },
        children,
    };
};
/**
 * @description 添加一个空白的CnLayoutBlock
 */
export const createEmptyBlockSnippet = ({ blockProps, blockChildren, } = {}) => {
    const baseSchema = {
        componentName: BLOCK,
        title: $i18n.get({ id: 'Block', dm: '块' }),
        props: {
            isCnLayoutBlock: true,
            _context: {
                type: 'JSExpression',
                value: 'this',
            },
            ...blockProps,
        },
    };
    return blockChildren
        ? {
            ...baseSchema,
            children: [blockChildren],
        }
        : baseSchema;
};
/**
 * @description 添加一个包含CnCard的CnLayoutBlock
 */
export const createBlockSnippet = ({ blockProps, cardProps, cardChildren, } = {}) => {
    return createEmptyBlockSnippet({
        blockProps,
        blockChildren: createBlockInitialChildrenSnippet({
            cardProps,
            children: cardChildren,
        }),
    });
};
export const createRowColSnippet = (componentName = COL) => {
    return {
        componentName,
        title: componentName === COL
            ? $i18n.get({ id: 'ColumnContainer', dm: '列容器' })
            : $i18n.get({ id: 'RowContainer', dm: '行容器' }),
        props: {},
        children: [],
    };
};
export function createSectionInitialChildren() {
    return [
        createBlockSnippet({
            blockProps: {
                span: 6,
            },
        }),
        createBlockSnippet({
            blockProps: {
                span: 6,
            },
        }),
    ];
}
export const createSectionSnippet = ({ blockProps } = {}) => {
    return {
        componentName: SECTION,
        title: $i18n.get({ id: 'FreeLayoutContainer', dm: '自由布局容器' }),
        props: {},
        children: [createBlockSnippet({ blockProps })],
    };
};
export const createAsideSnippet = () => {
    return {
        componentName: 'CnLayoutAside',
        title: $i18n.get({ id: 'Sidebar', dm: '侧边栏' }),
        props: {},
        children: [createCellSnippet(createSectionSnippet())],
    };
};
export const createCellSnippet = (children) => {
    return {
        componentName: 'CnLayoutCell',
        title: $i18n.get({ id: 'Container', dm: '容器' }),
        props: {},
        children: children || [],
    };
};
export function createHeaderSnippet() {
    return {
        componentName: 'CnLayoutHeader',
        title: $i18n.get({ id: 'PageHeader', dm: '页头' }),
        props: {},
        children: [createCellSnippet()],
    };
}
export function getGroupSetterSnippet(config) {
    const { outerConfig, items } = config || {};
    return {
        type: 'group',
        title: $i18n.get({ id: 'TERM.Grouping', dm: '分组' }),
        display: 'accordion',
        items,
        ...outerConfig,
    };
}
export function getMixedSetterSnippet(config) {
    const { setters } = config || {};
    return {
        componentName: 'MixedSetter',
        props: {
            setters,
        },
    };
}
